{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/DOLOPLUS2",
	"name": "DOLOPLUS-2",
	"language": "fr-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "Doloplus-2",
	"purpose": "Évaluation comportementale de la douleur",
	"description": "Le score 0 est attribué pour tout comportement normal alors que le score 3 est attribué pour le niveau de douleur le plus élevé. Le score total varie entre 0 et 30. Le score total ne reflète pas tant le niveau de douleur à un moment spécifique mais plutôt la progression de la douleur perçue.",
	"item": [
		{
			"type": "group",
			"linkId": "20100",
			"text": "Retentissement somatique",
			"item": [
				{
					"linkId": "20200",
					"prefix": "1",
					"text": "Plaintes somatiques",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "20201",
								"display": "Pas de plainte"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "20202",
								"display": "Plaintes uniquement à la sollicitation"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "20203",
								"display": "Plaintes spontanées occasionnelles"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "20204",
								"display": "Plaintes spontanées continues"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				},
				{
					"linkId": "20300",
					"prefix": "2",
					"text": "Positions antalgiques au repos",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "20301",
								"display": "Pas de position antalgique"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "20302",
								"display": "Le sujet évite certaines positions de façon occassionnelle"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "20303",
								"display": "Position antalgique permanente et efficace"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "20304",
								"display": "Position antalgique permanente inefficace"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				},
				{
					"linkId": "20400",
					"prefix": "3",
					"text": "Protection de zones douloureuses",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "20401",
								"display": "Pas de protection"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "20402",
								"display": "Protection à la sollicitation n’empêchant pas la poursuite de l’examen ou des soins"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "20403",
								"display": "Protection à la sollicitation empêchant tout examen ou soin"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "20404",
								"display": "Protection au repos, en l’absence de toute sollicitation"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				},
				{
					"linkId": "20500",
					"prefix": "4",
					"text": "Mimique",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "20501",
								"display": "Mimique habituelle"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "20502",
								"display": "Mimique semblant exprimer la douleur à la sollicitation"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "20503",
								"display": "Mimique semblant exprimer la douleur en l’absence de toute sollicitation"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "20504",
								"display": "Mimique inexpressive en permanence et de manière inhabituelle (atone, figée, regard vide)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				},
				{
					"linkId": "20600",
					"prefix": "5",
					"text": "Sommeil",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "20601",
								"display": "Sommeil habituel"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "20602",
								"display": "Difficultés d’endormissement"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "20603",
								"display": "Réveils fréquents (agitation motrice)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "20604",
								"display": "Insomnie avec retentissement sur les phases d’éveil"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				}
			]
		},
		{
			"type": "group",
			"linkId": "20700",
			"text": "Retentissement psychomoteur",
			"item": [
				{
					"linkId": "20800",
					"prefix": "6",
					"text": "Toilette et/ou habillage",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "20801",
								"display": "Possibilités habituelles inchangées"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "20802",
								"display": "Possibilités habituelles peu diminuées (précautionneux mais complet)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "20803",
								"display": "Possibilités habituelles très diminuées, toilette et/ou habillage étant difficiles et partiels"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "20804",
								"display": "Toilette et/ou habillage impossibles, le malade exprimant son opposition à toute tentative"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				},
				{
					"linkId": "20900",
					"prefix": "7",
					"text": "Mouvements",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "20901",
								"display": "Possibilités habituelles inchangées"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "20902",
								"display": "Possibilités habituelles peu diminuées (précautionneux mais complet)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "20903",
								"display": "Possibilités habituelles très diminuées, toilette et/ou habillage étant difficiles et partiels"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "20904",
								"display": "Toilette et/ou habillage impossibles, le malade exprimant son opposition à toute tentative"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				}
			]
		},
		{
			"type": "group",
			"linkId": "21000",
			"text": "Retentissement psychosocial",
			"item": [
				{
					"linkId": "21100",
					"prefix": "8",
					"text": "Communication",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "21101",
								"display": "Inchangée"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "21102",
								"display": "Intensifiée (la personne attire l’attention de manière inhabituelle)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "21103",
								"display": "Diminuée (la personne s’isole)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "21104",
								"display": "Absence ou refus de toute communication"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				},
				{
					"linkId": "21200",
					"prefix": "9",
					"text": "Vie sociale",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "21201",
								"display": "Participation habituelle aux différentes ativités (repas, animations, ateliers thérapeutiques, ...)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "21202",
								"display": "Participation aux différentes activités uniquement à la sollicitation"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "21203",
								"display": "Refus partiel de participer aux différentes activités"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "21204",
								"display": "Refus de toute vie sociale"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				},
				{
					"linkId": "21300",
					"prefix": "10",
					"text": "Troubles du comportement",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "21301",
								"display": "Comportement habituel"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "21302",
								"display": "Troubles du comportement à la sollicitation et itératif"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "21303",
								"display": "Troubles du comportement à la sollicitation et permanent"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "21304",
								"display": "Troubles du comportement permanent (en dehors de toute sollicitation)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					]
				}
			]
		}
	]
}
